import {
	GET_RETIRE_APPLICATION_SUCCESS,
	PATCH_INVESTOR_APPLICATION_SUCCESS,
	POST_USER_SUCCESS,
} from 'stash/actions/api';
import { SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS } from 'stash/actions/investorApplication';
import { BOOTSTRAP_GET_INVESTOR_APPLICATION_SUCCESS } from 'stash/store/bootstrapActions';

type InvestorApplicationState = Record<string, unknown>;

type InvestorApplicationAction =
	| {
			type: typeof POST_USER_SUCCESS;
			response: { investor_application: Record<string, unknown> };
	  }
	| {
			type: typeof BOOTSTRAP_GET_INVESTOR_APPLICATION_SUCCESS;
			response: { investor_application: Record<string, unknown> };
	  }
	| {
			type: typeof PATCH_INVESTOR_APPLICATION_SUCCESS;
			response: { investor_application: Record<string, unknown> };
	  }
	| {
			type: typeof GET_RETIRE_APPLICATION_SUCCESS;
			response: {
				retire_questions: unknown;
				retire_constants: unknown;
			};
	  }
	| {
			type: typeof SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS;
			payload: Record<string, unknown>;
	  }
	| { type: string };

const investor_application = (
	state: InvestorApplicationState = {},
	action: InvestorApplicationAction
): InvestorApplicationState => {
	switch (action.type) {
		case POST_USER_SUCCESS:
		case BOOTSTRAP_GET_INVESTOR_APPLICATION_SUCCESS: {
			const a = action as Extract<
				InvestorApplicationAction,
				| { type: typeof POST_USER_SUCCESS }
				| { type: typeof BOOTSTRAP_GET_INVESTOR_APPLICATION_SUCCESS }
			>;
			return {
				...state,
				...a.response.investor_application,
			};
		}

		case PATCH_INVESTOR_APPLICATION_SUCCESS: {
			const a = action as Extract<
				InvestorApplicationAction,
				{ type: typeof PATCH_INVESTOR_APPLICATION_SUCCESS }
			>;
			return {
				...state,
				...a.response.investor_application,
			};
		}

		case GET_RETIRE_APPLICATION_SUCCESS: {
			const a = action as Extract<
				InvestorApplicationAction,
				{ type: typeof GET_RETIRE_APPLICATION_SUCCESS }
			>;
			return {
				...state,
				retire_questions: a.response.retire_questions,
				retire_constants: a.response.retire_constants,
			};
		}

		case SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS: {
			const a = action as Extract<
				InvestorApplicationAction,
				{ type: typeof SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS }
			>;
			const { payload } = a;
			return {
				...state,
				...payload,
			};
		}
		default:
			return state;
	}
};

export default investor_application;
